module.exports = __webpack_public_path__ + "static/media/UN-15.71a46806.jpg";